import React, { useEffect, useState } from "react";
import { useAuth } from "./auth.jsx";
import { supabase } from "./supabaseClient.js";

const fmt = (d) => { try { return new Date(d).toLocaleString("ar", { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "2-digit" }); } catch { return "-"; } };
const dur = (a, b) => {
  const m = Math.max(0, Math.round((new Date(b) - new Date(a)) / 60000));
  if (m < 1) return "أقل من دقيقة";
  if (m < 60) return m + " د";
  return Math.floor(m / 60) + " س " + (m % 60) + " د";
};

export default function ActivityLog({ onClose }) {
  const { users, members } = useAuth();
  const [rows, setRows] = useState(null);
  const [fn, setFn] = useState("");
  const [fd, setFd] = useState("");
  const nameOf = (id) => {
    const u = (users || []).find((x) => x.id === id) || (members || []).find((x) => x.id === id);
    return (u && (u.fullName || u.full_name || u.email)) || "عضو";
  };
  useEffect(() => {
    let alive = true;
    const load = async () => { try {
      const { data, error } = await supabase.from("user_sessions").select("id,profile_id,login_at,last_seen,ip").order("login_at", { ascending: false }).limit(100);
      if (!alive) return;
      if (error) { setRows([]); return; }
      setRows(data || []);
    } catch { if (alive) setRows([]); } };
    load();
    const t = setInterval(load, 30000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  const now = Date.now();
  const shown = (rows || []).filter((r) => {
    const nm = nameOf(r.profile_id);
    const okN = !fn.trim() || nm.toLowerCase().includes(fn.trim().toLowerCase());
    const okD = !fd || String(r.login_at).slice(0, 10) === fd;
    return okN && okD;
  });
  const S = {
    wrap: { position: "fixed", inset: 0, zIndex: 900, background: "rgba(12,19,48,.45)", backdropFilter: "blur(6px)", WebkitBackdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", direction: "rtl" },
    box: { width: "min(760px, 94vw)", maxHeight: "82vh", overflowY: "auto", background: "color-mix(in srgb, var(--surface) 15%, transparent)", backdropFilter: "blur(30px) saturate(1.6)", WebkitBackdropFilter: "blur(30px) saturate(1.6)", border: "1.5px solid transparent", borderImage: "var(--card-glow) 1", borderRadius: 0, padding: "26px 28px", boxShadow: "10px 10px 0 color-mix(in srgb, var(--accent) 38%, transparent)", animation: "u4Up .3s cubic-bezier(.34,1.56,.64,1) both" },
    head: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 },
    title: { fontWeight: "bold", fontSize: 20, color: "var(--text)", margin: 0 },
    th: { fontWeight: 800, fontSize: 14, color: "var(--faint)", padding: "8px 6px", textAlign: "right", borderBottom: "1px solid var(--line)" },
    td: { fontSize: 14.5, color: "var(--text)", padding: "11px 6px", border: "none" },
    note: { fontSize: 13.5, color: "var(--faint)", textAlign: "center", marginTop: 12 },
  };
  return (
    <div className="ag-modal-bg am-bg" onClick={onClose}>
      <div className="ag-modal wide u4 u4-win" onClick={(e) => e.stopPropagation()}>
        <div style={S.head}>
          <h3 style={S.title}>سجلّ الدخول والمتابعة</h3>
          <button className="ag-btn xs" onClick={onClose}>إغلاق</button>
        </div>
        <div style={{ display: "flex", gap: 10, marginBottom: 14, alignItems: "center" }}>
          <input className="u4-in" style={{ flex: 1, padding: "7px 11px", fontSize: 13.5 }} value={fn} onChange={(e) => setFn(e.target.value)} placeholder="تصفية بالاسم" />
          <input type="date" className="u4-in" style={{ width: 170, padding: "6px 11px", fontSize: 13.5 }} value={fd} onChange={(e) => setFd(e.target.value)} />
          {(fn || fd) && <button className="ag-btn xs" onClick={() => { setFn(""); setFd(""); }}>مسح</button>}
        </div>
        {rows === null && <div style={{ color: "var(--faint)", padding: 20, textAlign: "center" }}>جارٍ التحميل…</div>}
        {rows && rows.length === 0 && <div style={{ color: "var(--faint)", padding: 20, textAlign: "center" }}>لا سجلات بعد - تظهر مع أول دخول.</div>}
        {rows && rows.length > 0 && shown.length === 0 && <div style={{ color: "var(--faint)", padding: 20, textAlign: "center" }}>لا نتائج مطابقة للتصفية.</div>}
        {rows && shown.length > 0 && (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr>
              <th style={S.th}>الاسم</th><th style={S.th}>وقت الدخول</th><th style={S.th}>آخر ظهور</th><th style={S.th}>المدّة</th><th style={S.th}>عنوان IP</th><th style={S.th}>الحالة</th>
            </tr></thead>
            <tbody>
              {shown.map((r) => {
                const active = now - new Date(r.last_seen).getTime() < 3 * 60000;
                return (
                  <tr key={r.id}>
                    <td style={{ ...S.td, fontWeight: 700 }}>{nameOf(r.profile_id)}</td>
                    <td style={S.td}>{fmt(r.login_at)}</td>
                    <td style={S.td}>{active ? "-" : fmt(r.last_seen)}</td>
                    <td style={S.td}>{dur(r.login_at, r.last_seen)}</td>
                    <td style={{ ...S.td, direction: "ltr", textAlign: "right", fontSize: 13.5, fontFamily: "ui-monospace, monospace", color: "var(--faint)" }}>{r.ip || "-"}</td>
                    <td style={{ ...S.td, fontWeight: 800, color: active ? "#059669" : "var(--faint)" }}>{active ? "نشط الآن" : "خرج"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        <div style={S.note}>هذا السجلّ ظاهر لك (المدير) فقط ومخفيّ عن الجميع.</div>
      </div>
    </div>
  );
}
